/**
 * Legale **Bewegungen** (MOVE) — Ziehen auf ein freies Feld.
 *
 * Schlagen ist eine eigene Aktion und steht in `legal-captures.ts`: ein besetztes Feld ist
 * hier nie ein Ziel, auch kein gegnerisch besetztes (§12 — ein Zug ist genau eine Aktion).
 *
 * Die Pfade — sechs gerade Achsen plus Ring — kommen aus `path-walk.ts`, gemeinsam mit dem
 * Schlagen. Hier steht nur, was ein **Bewegungsziel** ausmacht.
 */
import { isOccupied, requirePiece } from './board-state.js';
import { isGoalCell, mayEnterGoalCell } from './goal-cell.js';
import { hexKey } from './hex.js';
import { canJump, movementRange } from './pieces.js';
import { walkPaths } from './path-walk.js';
/** Darf die Figur auf diesem Feld **landen**? */
function canLandOn(context, cell, piece) {
    if (isOccupied(context.state, cell))
        return false;
    if (isGoalCell(cell) && !mayEnterGoalCell(piece.type))
        return false;
    return true;
}
/**
 * Alle Felder, auf die diese Figur in diesem Zug ziehen darf.
 *
 * Doppelte Ziele — ein Feld, das gerade **und** über den Ring erreichbar ist — erscheinen
 * nur einmal.
 */
export function getLegalMoves(context, pieceId) {
    const piece = requirePiece(context.state, pieceId);
    const targets = new Map();
    walkPaths(context, piece, movementRange(context.config, piece.type), canJump(context.config, piece.type), ({ cell }) => {
        if (canLandOn(context, cell, piece))
            targets.set(hexKey(cell), cell);
    });
    return [...targets.values()];
}
//# sourceMappingURL=legal-moves.js.map